// Returns the object of the activePackage that is selected
const getActivePackageObject = (pk, packages = []) => {
  if (pk === 0) {
    return {};
  }
  const activePkgObject = packages.find((pkg) => {
    return pkg.pk === pk;
  });
  return activePkgObject;
};

export default getActivePackageObject;
